import { render, staticRenderFns } from "./veStuAssocRelation.vue?vue&type=template&id=0d095f10&scoped=true"
import script from "./veStuAssocRelation.vue?vue&type=script&lang=js"
export * from "./veStuAssocRelation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d095f10",
  null
  
)

export default component.exports